module.exports = __webpack_public_path__ + "static/img/screen5.960a7006.png";